module.exports = __webpack_public_path__ + "static/media/v_logo_vip-vichy.cc02a943.png";